export const REGISTRATION_STEP_SHOW_ROLES_SELECTION = 'REGISTRATION_STEP_SHOW_ROLES_SELECTION';
export const REGISTRATION_STEP_SHOW_CONFIRMATION = 'REGISTRATION_STEP_SHOW_CONFIRMATION';
export const REGISTRATION_STEP_SHOW_PERSONAL_INFO = 'REGISTRATION_STEP_SHOW_PERSONAL_INFO';
export const ALL_ROLES_BY_APP_KEY = 'ALL_ROLES_BY_APP_KEY';
export const ULTIMATE_PARENT_COMPANY_ALLOWED_ROLES = 'ULTIMATE_PARENT_COMPANY_ALLOWED_ROLES';
export const ULTIMATE_PARENT_COMPANY = 'ULTIMATE_PARENT_COMPANY';
export const USER_INPUT_PERSONAL_INFO_CHANGE = 'USER_INPUT_PERSONAL_INFO_CHANGE';
export const SELF_REGISTRATION_SETTINGS = 'SELF_REGISTRATION_SETTINGS';
export const SELF_REGISTRATION_ATTRIBUTE_TYPES = 'SELF_REGISTRATION_ATTRIBUTE_TYPES';
export const BRAND_CONFIG_RECEIVED = 'BRAND_CONFIG_RECEIVED';
export const REGISTRATION_SESSION_ACTIVE = 'REGISTRATION_SESSION_ACTIVE';
